import React, { useContext } from "react";
import Modal from "../Modal";
import ModalContext from "../../../../infrastructure/Contexts/components/ModalWrapper/context";

export default function ModalProvider() {
  const { isOpen, closeModal, modalTitle, modalChildren } =
    useContext(ModalContext);

  return (
    <Modal isOpen={isOpen} setIsOpen={closeModal} title={modalTitle}>
      {modalChildren}
    </Modal>
  );
}
